import React from "react";
import GlobalStyles from 'styles/GlobalStyles';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import MainLandingPage from "./MainLandingPage.js";
import AboutUsPage from "pages/AboutUs.js";
import ContactUsPage from "pages/ContactUs.js";
import TermsOfServicePage from "pages/TermsOfService.js";
import PrivacyPolicyPage from "pages/PrivacyPolicy.js";
import NotFoundPage from "pages/NotFoundPage.js";
import Work from "pages/Work.js";
import ServicesPage from "pages/Services.js";
import RefundPolicy from "pages/RefundPolicy.js";
import PricingPage from "pages/Pricing.js";
import BlogIndex from "pages/BlogIndex.js";
import FAQsPage from "pages/FAQs.js";
import CareersPage from "pages/Careers.js";
import ScrollToTop from "components/jhala/ScrollToTop.js";

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<MainLandingPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/work" element={<Work />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/development" element={<Navigate to="/work" replace />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </>
  );
}